module.exports = __webpack_public_path__ + "img/new_index_customers10.b7db7d2f.png";